import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions'
import SupplierSearchBox from '../components/SupplierSearchBox';
import { loadTaxonomyAsyncThunk, searchTaxonomyAsyncThunk, applyFilter, removeFilter, resetAndReplaceFilter } from '../actions/ProductsSearchActions'
import { ThunkDispatch } from 'redux-thunk';
import { SearchFilter, CategoryFilter, PropertyFilter } from '../../models/SearchFilter';
import { RouteComponentProps } from 'react-router';
import { SupplierProductMapping } from '../../api/models/SupplierProductMapping';
import { sendCatalogUpdatePropositionAsyncThunk } from '../../Supplier/actions/SupplierActions';
import { UpdateCatalogueOptionFilled } from '../../Supplier/components/UpdateCatalogueRequest';

type OwnPropsType = {
  searchString?: string,
  onSaveChange: (spm: SupplierProductMapping) => void,
  onMappingFinish: () => void,
  mappingObj: SupplierProductMapping,
  showPriceControls: boolean
}

const mapStateToProps = (state: RootState, ownProps: OwnPropsType) => ({
  taxonomyLeafs: state.productsSearchRdc.taxonomyLeafs,
  taxonomy: state.productsSearchRdc.taxonomy,
  currentProducts: state.productsSearchRdc.searchResults,
  facetResults: state.productsSearchRdc.categoriesFacetResult,
  appliedCategoryFilters: state.productsSearchRdc.appliedCategoryFilters,
  currentCategoryFilters: state.productsSearchRdc.currentCategoryFilters,
  topCategoryFilters: state.productsSearchRdc.topCategoryFilters,
  appliedPropertyFilters: state.productsSearchRdc.appliedPropertyFilters,
  currentProductProperties: state.productsSearchRdc.currentProductProperties,
  searchBusy: state.productsSearchRdc.searchBusy,
  totalResults: state.productsSearchRdc.totalResults,
  highlights: state.productsSearchRdc.highlights,
  predefinedSearchString: ownProps.searchString,
  onSaveChange: ownProps.onSaveChange,
  mappingObj: ownProps.mappingObj,
  isUpdateMappingBusy: state.supplierRdc.updateMappingsBusy,
  isUpdateMappingSuccess : state.supplierRdc.updateMappingSuccess,
  onMappingFinish: ownProps.onMappingFinish,
  showPriceControls: ownProps.showPriceControls,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
  return {
    loadTaxonomy: async () => {
      await dispatch(loadTaxonomyAsyncThunk())
    },
    searchTaxonomy: async (query: string, startFrom: number, limit: number, filters: { [name: string]: string[] }) => {
      await dispatch(searchTaxonomyAsyncThunk(query, startFrom, limit, filters, false))
    },
    applyFilter: (filter: SearchFilter) => {
      dispatch(applyFilter(filter))
    },
    removeFilter: (filter: SearchFilter) => {
      dispatch(removeFilter(filter))
    },
    replaceFilter: (categoryFilter?: CategoryFilter | null, propertyFilter?: PropertyFilter | null) => {
      dispatch(resetAndReplaceFilter({ categoryFilter, propertyFilter }))
    },
    sendCatUpdateProposition: async (request: UpdateCatalogueOptionFilled) => {
      await dispatch(sendCatalogUpdatePropositionAsyncThunk(request))
    }
  }
}

export type SupplierProductsSearchBoxProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any>

export const SupplierProductsSearchBoxCnn = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupplierSearchBox);